import { defMathOpN } from "./compile/emit.js";
const [mulN, mulN2, mulN3, mulN4] = defMathOpN("*");
export {
  mulN,
  mulN2,
  mulN3,
  mulN4
};
